"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTargetOffer = exports.TARGET_OFFER_MAX_WAIT_MS = exports.TARGET_OFFER_POLL_INTERVAL = void 0;
const react_1 = __importStar(require("react"));
const string_format_1 = require("@ampcore/string-format");
exports.TARGET_OFFER_POLL_INTERVAL = 100;
exports.TARGET_OFFER_MAX_WAIT_MS = 3000;
function useTargetOffer(mboxName, fallbackProps) {
    const [offerJson, setOfferJson] = (0, react_1.useState)(null);
    const [isOfferLoading, setIsOfferLoading] = (0, react_1.useState)(false);
    const attemptsRef = react_1.default.useRef(0);
    const maxAttempts = Math.ceil(exports.TARGET_OFFER_MAX_WAIT_MS / exports.TARGET_OFFER_POLL_INTERVAL);
    (0, react_1.useEffect)(() => {
        if (!mboxName)
            return;
        let normalizedMboxName = mboxName;
        if (mboxName.endsWith('Mbox')) {
            normalizedMboxName = (0, string_format_1.camelCase)(mboxName);
        }
        else {
            normalizedMboxName = (0, string_format_1.camelCase)(`${mboxName}Mbox`);
        }
        let pollTimeout = null;
        attemptsRef.current = 0;
        setIsOfferLoading(true);
        setOfferJson(null);
        const pollForOffers = () => {
            if (!window.adobe?.target?.getOffers) {
                if (attemptsRef.current < maxAttempts) {
                    attemptsRef.current++;
                    pollTimeout = setTimeout(pollForOffers, exports.TARGET_OFFER_POLL_INTERVAL);
                }
                else {
                    setIsOfferLoading(false);
                }
                return;
            }
            window.adobe.target
                .getOffers({
                request: {
                    execute: {
                        mboxes: [
                            {
                                name: normalizedMboxName,
                                index: 0
                            }
                        ]
                    }
                }
            })
                .then((response) => {
                const res = response;
                const content = res.execute?.mboxes?.[0]?.options?.[0]?.content;
                setOfferJson(content ?? null);
                setIsOfferLoading(false);
            })
                .catch(() => {
                setIsOfferLoading(false);
                console.error(`use target offer error occurred for ${normalizedMboxName}`);
            });
        };
        pollForOffers();
        return () => {
            if (pollTimeout)
                clearTimeout(pollTimeout);
        };
    }, [mboxName]);
    // If offerJson is null or an empty object, use fallbackProps
    const isEmptyObject = offerJson && Object.keys(offerJson).length === 0;
    const effectiveProps = offerJson && !isEmptyObject ? offerJson : fallbackProps;
    return { effectiveProps, isOfferLoading };
}
exports.useTargetOffer = useTargetOffer;
